/* eslint-disable react/prop-types,no-unused-vars */
import React from 'react';
import * as _ from 'lodash';
import { step7ExpenseLookup, step8ExpenseLookup, step6ExpenseLookup, step11ExpenseLookup, step9ExpenseLookup } from '../../../dataMapper/claimCodeMapper';
import { Table } from '../../../../../components/Table';
import TH from '../../../../../components/Table/TH';
import TR from '../../../../../components/Table/TR';
import TD from '../../../../../components/Table/TD';


const DocumentTable = (props) => {
  const renderIcon = (hasFile) => {
    if (hasFile) {
      return <i style={{ color: '#44b4a6' }} className="fa fa-check fa-2x" aria-hidden="true" />;
    }
    return <i style={{ color: 'orange' }} className="fa fa-times fa-2x" aria-hidden="true" />;
  };
  const { selectedBenefits } = props.step5Data;
  const { attachDocuments } = props.step12Data;
  const { medicalExpenses } = props.step8Data;

  const { additionalItems, delayedLuggageExpenses } = props.step7Data;
  const { cancellationExpenses, delayedTravelExpenses, additionalExpenses } = props.step6Data;
  const { bicyclePackOptionalExpensesClaimed, golfPackOptionalExpensesClaimed,
    personalLiabilitiesExpensesClaimed, areYouClaimingForPersonalLiability, anythingElseExpensesClaimed, isThereAnyThingElseYouWouldLikeToClaimFor,
    areYouClaimingForGolfPackOptionalCover, areYouClaimingForBicyclePackOptionalCover } = props.step11Data;
  let step8Amount = 0;
  let step7Amount = 0;
  let step6Amount = 0;
  const step9Amount = props.step9Data ? +props.step9Data.amountClaimed : 0;
  let step11Amount = 0;
  let sum = 0;
  const list = (!!selectedBenefits && typeof selectedBenefits.toJS === 'function') ? selectedBenefits.toJS() : (selectedBenefits || []);
  const isStep7Selected = (list.filter((d) => ((step7ExpenseLookup.claimCodeList).filter((c) => c === d.claimCode)).length > 0)).length > 0;
  const isStep8Selected = (list.filter((d) => ((step8ExpenseLookup.claimCodeList).filter((c) => c === d.claimCode)).length > 0)).length > 0;
  const isStep11Selected = (list.filter((d) => ((step11ExpenseLookup.claimCodeList).filter((c) => c === d.claimCode)).length > 0)).length > 0;
  const isStep6Selected = (list.filter((d) => ((step6ExpenseLookup.claimCodeList).filter((c) => c === d.claimCode)).length > 0)).length > 0;
  const isStep9Selected = (list.filter((d) => ((step9ExpenseLookup.claimCodeList).filter((c) => c === d.claimCode)).length > 0)).length > 0;
  if (isStep6Selected && cancellationExpenses.length) {
    step6Amount += _.sumBy(cancellationExpenses, (o) => +o.prePaidAmount);
  }
  if (isStep6Selected && delayedTravelExpenses.length) {
    step6Amount += _.sumBy(delayedTravelExpenses, (o) => +o.amount);
  }

  if (isStep7Selected && additionalItems && additionalItems.length > 0) {
    step7Amount += _.sumBy(additionalItems, (o) => +o.amountClaimed);
  }
  if (isStep7Selected && delayedLuggageExpenses && delayedLuggageExpenses.length > 0) {
    step7Amount += _.sumBy(delayedLuggageExpenses, (o) => +o.amountClaimed);
  }

  if (isStep8Selected && medicalExpenses && medicalExpenses.length > 0) {
    step8Amount = _.sumBy(medicalExpenses, (o) => +o.amountCharged);
  }
  if (areYouClaimingForBicyclePackOptionalCover === 'true' && bicyclePackOptionalExpensesClaimed.length) {
    step11Amount += _.sumBy(bicyclePackOptionalExpensesClaimed, (o) => +o.amount);
  }
  if (areYouClaimingForGolfPackOptionalCover === 'true' && golfPackOptionalExpensesClaimed.length) {
    step11Amount += _.sumBy(golfPackOptionalExpensesClaimed, (o) => +o.amount);
  }
  if (areYouClaimingForPersonalLiability === 'true' && personalLiabilitiesExpensesClaimed.length) {
    step11Amount += _.sumBy(personalLiabilitiesExpensesClaimed, (o) => +o.amount);
  }
  if (isThereAnyThingElseYouWouldLikeToClaimFor === 'true' && anythingElseExpensesClaimed.length) {
    step11Amount += _.sumBy(anythingElseExpensesClaimed, (o) => +o.amount);
  }
  sum = step6Amount + step7Amount + step8Amount + step9Amount + step11Amount;
  const renderStep8 = () => (
      medicalExpenses.map((x, idx) => (
        <TR key={idx} noHover>
          {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={medicalExpenses.length}>Medical</TD>}
          <TD className={`${idx === medicalExpenses.length - 1 ? 'document-table-bottom document-table-right align-middle' : 'align-middle document-table-right'}`}>{x.nameOfDoctorOrProvider} | {x.treatmentReceived}</TD>
          <TD className={`${idx === medicalExpenses.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>${x.amountCharged ? (+x.amountCharged).toLocaleString('en') : 0}</TD>
          <TD className={`${idx === medicalExpenses.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
          {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={medicalExpenses.length} > {renderIcon(((step8ExpenseLookup.claimCodeList).filter((d) => (attachDocuments.filter((c) => c.benefitCode === d)).length > 0)).length > 0)}</TD>}
        </TR>
      ))
    );

  const renderStep7 = () => {
    const data = additionalItems.concat(delayedLuggageExpenses);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Personal Items</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.descriptionOfItem}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>${x.amountClaimed ? (+x.amountClaimed).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.amountClaimedCurrency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(((step7ExpenseLookup.claimCodeList).filter((d) => (attachDocuments.filter((c) => c.benefitCode === d)).length > 0)).length > 0)}</TD>}
      </TR>
    ));
  };

  const renderStep6 = () => {
    const additionalMapper = additionalExpenses.map((x) => ({
      description: `${x.supplier} | ${x.description}`,
      amount: x.amountPaid,
      currency: x.amountPaidCurrency,
    }));
    const delayedTravelExpensesMapper = delayedTravelExpenses.map((x) => ({
      description: x.description,
      amount: x.amount,
      currency: x.amountCurrency,
    }));

    const cancellationExpensesMapper = cancellationExpenses.map((x) => ({
      description: `${x.supplier} | ${x.cancelledBookingDescription}`,
      amount: x.prePaidAmount,
      currency: x.prePaidAmountCurrency,
    }));
    const data = additionalMapper.concat(delayedTravelExpensesMapper, cancellationExpensesMapper);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>Trip Cancellation and Additional Expenses</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.description}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>${x.amount ? (+x.amount).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(((step6ExpenseLookup.claimCodeList).filter((d) => (attachDocuments.filter((c) => c.benefitCode === d)).length > 0)).length > 0)}</TD>}
      </TR>
    ));
  };

  const renderStep11 = () => {
    const data = personalLiabilitiesExpensesClaimed.concat(golfPackOptionalExpensesClaimed, bicyclePackOptionalExpensesClaimed, anythingElseExpensesClaimed);
    return data.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-top document-table-left document-table-right" rowSpan={data.length}>Other</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.description}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>${x.amount ? (+x.amount).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-top document-table-right" rowSpan={data.length}> {renderIcon(((step11ExpenseLookup.claimCodeList).filter((d) => (attachDocuments.filter((c) => c.benefitCode === d)).length > 0)).length > 0)}</TD>}
      </TR>
    ));
  };
  return (
    <Table>
      <thead>
        <tr>
          <TH className="document-table-top document-table-left document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
           Benefit
          </TH>
          <TH className="document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
            Description
          </TH>
          <TH className="text-right document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
            Amount Claimed
          </TH>
          <TH className="document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
            Currency
          </TH>
          <TH className="document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
            Documents Provided
          </TH>
        </tr>
      </thead>
      <tbody>
        {isStep8Selected && renderStep8() }
        {isStep7Selected && renderStep7()}
        {isStep6Selected && renderStep6()}
        {isStep9Selected && !!step9ExpenseLookup.areYouClaimingForRentalVehicleExcess.claimCode && <TR noHover>
          <TD className="align-middle document-table-left  document-table-bottom document-table-right">Rental Vehicle</TD>
          <TD className="document-table-bottom align-middle document-table-right" >{props.step9Data.description}</TD>
          <TD className="document-table-bottom text-right align-middle  document-table-right">${(+step9Amount).toLocaleString('en')}</TD>
          <TD className="document-table-bottom align-middle document-table-right">{ props.step9Data.actualRepairAmountCurrency}</TD>
          <TD style={{ textAlign: 'center' }} className="document-table-right document-table-top"> {renderIcon(((step9ExpenseLookup.claimCodeList).filter((d) => (attachDocuments.filter((c) => c.benefitCode === d)).length > 0)).length > 0)}</TD>
        </TR>}
        {isStep11Selected && renderStep11()}
      </tbody>
    </Table>
  );
};
export default DocumentTable;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step14/components/DocumentTable/index.js